"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AccordionButton", {
  enumerable: true,
  get: function get() {
    return _AccordionListItem.AccordionButton;
  }
});
Object.defineProperty(exports, "AccordionIcon", {
  enumerable: true,
  get: function get() {
    return _AccordionListItem.AccordionIcon;
  }
});
Object.defineProperty(exports, "AccordionList", {
  enumerable: true,
  get: function get() {
    return _AccordionList.AccordionList;
  }
});
Object.defineProperty(exports, "AccordionListItem", {
  enumerable: true,
  get: function get() {
    return _AccordionListItem.AccordionListItem;
  }
});
Object.defineProperty(exports, "AccordionPanel", {
  enumerable: true,
  get: function get() {
    return _AccordionListItem.AccordionPanel;
  }
});
var _AccordionList = require("./AccordionList");
var _AccordionListItem = require("../../core/List/AccordionListItem");
function cov_1bng6t900k() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Accordion/index.ts";
  var hash = "a52e326968e2d633623ac007aaf20132d1de067b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Accordion/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a52e326968e2d633623ac007aaf20132d1de067b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1bng6t900k = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1bng6t900k();